var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { unByKey } from 'ol/Observable';
import React from 'react';
import debounce from '../utils/debounce';
import { Consumer } from '../containers/Map';

/**
 * Higher order component (HOC) that allows any other component to monitor map
 * state, as long as it is contained in a Map component.
 *
 * Provides props mapCenter, mapZoom, mapExtent and projCode.
 *
 * Provides callback props setCenter(center, zoom) and setZoom(zoom).
 */
export function provideMapState(WrappedComponent) {
  var MapStateMonitor = function (_React$Component) {
    _inherits(MapStateMonitor, _React$Component);

    function MapStateMonitor() {
      var _temp, _this, _ret;

      _classCallCheck(this, MapStateMonitor);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { isInited: false }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    MapStateMonitor.prototype.componentDidMount = function componentDidMount() {
      if (this.props.mapContext) this.bindEvents();
    };

    MapStateMonitor.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (this.props.mapContext && !prevProps.mapContext) this.bindEvents();
    };

    MapStateMonitor.prototype.bindEvents = function bindEvents() {
      var _this2 = this;

      var map = this.props.mapContext.map;

      if (map && map.getView()) {
        this.view = map.getView();
        this.addEvent(this.view.on('change:center', debounce(function (evt) {
          return _this2.onCenterChange();
        }, 500)));
        this.addEvent(this.view.on('change:resolution', debounce(function (evt) {
          return _this2.onZoomChange();
        }, 500)));

        this.onCenterChange();
      }
    };

    MapStateMonitor.prototype.onCenterChange = function onCenterChange() {
      this.setState({
        isInited: true,
        mapCenter: this.props.mapContext.getPaddedCenter(),
        mapZoom: this.view.getZoom(),
        projCode: this.view.getProjection().getCode(),
        mapExtent: this.view.calculateExtent(this.props.mapContext.map.getSize())
      });
    };

    MapStateMonitor.prototype.onZoomChange = function onZoomChange() {
      this.setState({
        mapZoom: this.view.getZoom()
      });
    };

    MapStateMonitor.prototype.componentWillUnmount = function componentWillUnmount() {
      // Disconnect from map
      if (this.eventKeys) {
        this.eventKeys.forEach(function (key) {
          return unByKey(key);
        });
      }
    };

    MapStateMonitor.prototype.addEvent = function addEvent(key) {
      if (!this.eventKeys) this.eventKeys = [];
      this.eventKeys.push(key);
    };

    MapStateMonitor.prototype.removeEvent = function removeEvent(key) {
      unByKey(key);
      var idx = this.eventKeys.indexOf(key);
      if (idx !== -1) this.eventKeys.splice(idx, 1);
    };

    MapStateMonitor.prototype.render = function render() {
      if (!this.state.isInited) return null;

      var mapContext = this.props.mapContext;

      if (!mapContext) return;

      return React.createElement(WrappedComponent, _extends({
        setCenter: mapContext.setCenterAndZoom,
        setZoom: mapContext.setZoom,
        fitViewAndZoom: mapContext.fitViewAndZoom,
        forceUpdateMap: mapContext.forceUpdateMap,
        redrawLayer: mapContext.redrawLayer
      }, this.state, this.props));
    };

    return MapStateMonitor;
  }(React.Component);

  var MapStateConsumer = function (_React$Component2) {
    _inherits(MapStateConsumer, _React$Component2);

    function MapStateConsumer() {
      _classCallCheck(this, MapStateConsumer);

      return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }

    MapStateConsumer.prototype.render = function render() {
      var _this4 = this;

      return React.createElement(
        Consumer,
        null,
        function (mapContext) {
          return React.createElement(MapStateMonitor, _extends({ mapContext: mapContext }, _this4.props));
        }
      );
    };

    return MapStateConsumer;
  }(React.Component);

  return MapStateConsumer;
}